import { isLocalStorageEnabled } from './localstorage'
import { POLL_POPUP_KEY } from './popup-const'
import {
  checkModalSupport, isActionArticleInCart,
  showModalAfterCartInactivity,
  showModalOnExitIntent
} from './popup-utils'

const POLL_POPUP_CLOSE_DAYS = 7
const POLL_POPUP_CLOSE_TIME = POLL_POPUP_CLOSE_DAYS * 24 * 60 * 60 * 1000

export const initPollPopup = function () {
  if (isActionArticleInCart() || !isLocalStorageEnabled()) {
    return
  }

  const popup = document.querySelector('[data-js-poll-popup]')

  if (!popup) {
    return
  }

  // return if popup is not supported
  if (!checkModalSupport(popup)) {
    return
  }

  const now = Date.now()
  const closeButton = popup.querySelector('[data-js-modal-close]')
  const participationButton = popup.querySelector('[data-js-poll-participation-button]')
  const closeUntil = now + POLL_POPUP_CLOSE_TIME

  const checkCallback = function () {
    const closedUntil = localStorage.getItem(POLL_POPUP_KEY)
    if (closedUntil && now < Number(closedUntil)) {
      return false
    }

    return true
  }

  if (checkCallback() === false) {
    return
  }

  if (window.matchMedia('(max-width: 768px)').matches) {
    showModalAfterCartInactivity(popup, 2800, checkCallback)
  } else {
    showModalOnExitIntent(popup, checkCallback)
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      localStorage.setItem(POLL_POPUP_KEY, closeUntil)
    })
  }

  if (participationButton) {
    participationButton.addEventListener('click', function () {
      localStorage.setItem(POLL_POPUP_KEY, closeUntil)
    })
  }
}
